import { faUsers } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import Authentication from "@yodlee/common-components/dist/types/interfaces/authentication";
import { ManageRoles as ManageRolesWidget } from "@yodlee/ycc-settings-widget";
import { Button, Drawer, Icon, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { LabelConfigs } from "../configurations";
import { AmplitudeEventsUtils } from "../utilities";

interface IProps {
    authentication: Authentication,
    onRoleChange: () => void,
    onClose: () => void,
    updateRolesData: boolean,
    rolesDataUpdated: () => void
}

const ManageRoles: React.FC<IProps> = ({ authentication, onRoleChange, onClose, updateRolesData, rolesDataUpdated }) => {
    const [visible, setVisible] = useState(false);
    const [updateModalData, setUpdateModalData] = useState(false);

    let isMD = useMediaQuery({ minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD });

    useEffect(() => {
        if (updateRolesData)
            setUpdateModalData(true);
    }, [updateRolesData])

    const manageRoleModal =
        <Drawer
            width="85vw"
            title="Role permissions"
            visible={visible}
            onClose={() => {
                setVisible(false);
                onClose();
                if (updateModalData) {
                    setUpdateModalData(false);
                    rolesDataUpdated();
                }
            }}
            destroyOnClose={updateModalData}
            placement="right"
            className="no-padding-drawer drawer-type-1"
        >

            <ManageRolesWidget
                onRoleChanges={onRoleChange}
                authentication={authentication}
                onCloseClick={() => {
                    onClose();
                    setVisible(false);
                    if (updateModalData) {
                        setUpdateModalData(false);
                        rolesDataUpdated();
                    }
                }}
            />
        </Drawer>

    return (
        <React.Fragment>
            {manageRoleModal}
            {
                isMD ?
                    <Button type="primary"
                        onClick={() => {
                            setVisible(!visible)
                            AmplitudeEventsUtils.manageRolePermissionsClick();
                        }}>
                        {LabelConfigs.MANAGE_ROLES}
                    </Button> :
                    <Tooltip trigger="hover" title={isMD ? null : LabelConfigs.MANAGE_ROLES} placement="left">
                        <Button type="link" className="no-padding no-margin"
                            onClick={() => {
                                setVisible(!visible)
                                AmplitudeEventsUtils.manageRolePermissionsClick();
                            }}>
                            <Icon className="font-size-xl" component={() => <FontAwesomeIcon icon={faUsers} />} />
                        </Button>
                    </Tooltip>
            }
        </React.Fragment>
    )
}

export default ManageRoles;